import { StorageModel } from 'src/State/Storage/StorageModel'
import { StorageModel as Storage } from '../models'

import { EmsProductType, EmsProductTypeValue } from 'src/Routes/Installation/InstallationModel'

export const storageDtoToModelTransformer = (value: StorageModel): Storage => ({
  serialNumber: value.serialNo,
  timestampInitCheck: value.timestamp_init_check,
  timestampFirstOnline: value.timestamp_first_online,
  timestampInstallDate: value.timestamp_install_date,
  ownerId: value.ownerID,
  addressId: value.Anschrift_ID,
  commissioningDeclaration: value.Inbe_Erklaerung,
  guaranteeDeclaration: value.Garantie_Erklaerung,
  YearConsumption: value.YearConsumption,
  referenceSystem: value.referenzSystem,
  installerId: value.installerID,
  softwareRelease: value.sw_release,
  updatePlatform: value.update_platform,
  accountKeyStatus: value.AccKeyStatus,
  deviceType: value.deviceType,
  couplingMode: value.couplingMode,
  hidden: value.hidden,
  tunnelPort: value.tunnelPort,
  label: value.label,
  maxProduction: value.maxProd,
  softwareUpdateDisabled: value.swUpdateDisabled,
  hardwareUpdateDisabled: value.hwUpdateDisabled,
  comment: value.comment,
  lastUpdate: value.lastUpdate,
  hideFromDeutschlandLive: value.hideFromDeutschlandLive,
  isFarm: value.isFarm,
  isServer: value.isServer,
  clients: value.clients,
  server: value.server,
  product: (value.product as EmsProductTypeValue) || EmsProductType.s10_e,
  offlineLevel: value.offlineLevel,
  stateOfCharge: value.soc,
  systemStatus: value.sysstatus,
  ownerName: value.ownerName,
  hasWallbox: value.hasWallbox,
  isDelivered: value.isDelivered,
  isInstalled: value.isInstalled,
  gpsLatitude: value.gpsLatitude,
  gpsLongitude: value.gpsLongitude,
  batteryCapacity: value.batteryCapacity,
})
